export const Required = value => {
    return (Array.isArray(value) && value.length == 0) || !value ? 'This field is required' : undefined;
}

export const RequiredNotBlank = value => {
    return !value ? 'This field is required' : !value.trim() ? 'This field is required' : undefined;
}

